import {
  GET_REGION_INIT,
  GET_REGION_SUCCESS,
  GET_REGION_FAILED,
  GET_STRATEGIES_INIT,
  GET_STRATEGIES_SUCCESS,
  GET_STRATEGIES_FAILED,
  CREATE_FUND_INIT,
  CREATE_FUND_SUCCESS,
  CREATE_FUND_FAILED,
  GET_SPECIALITIES_INIT,
  GET_SPECIALITIES_SUCCESS,
  GET_SPECIALITIES_FAILED,
} from "./constants";
const initialState = {
  loading: false,
  strategies: {},
  region: {},
  fund: {},
  specialities: [],
  subLoading: false,
};

export default function createFund(state = initialState, action) {
  switch (action.type) {
    case GET_REGION_INIT:
      return { ...state, loading: true };
    case GET_REGION_SUCCESS:
      let regionList = [];
      action?.payload.map(({ name, id }) => {
        return regionList.push({
          value: name,
          label: name,
          id: id,
        });
      });
      return { ...state, loading: false, region: regionList };
    case GET_REGION_FAILED:
      return { ...state, loading: false };
    case GET_STRATEGIES_INIT:
      return { ...state };
    case GET_STRATEGIES_SUCCESS:
      let strategiesList = [];
      action?.payload.map(({ name, id }) => {
        return strategiesList.push({
          value: name,
          label: name,
          id: id,
        });
      });
      return {
        ...state,
        strategies: strategiesList,
      };

    case GET_STRATEGIES_FAILED:
      return { ...state };
    case CREATE_FUND_INIT:
      return { ...state, loading: true };
    case CREATE_FUND_SUCCESS:
      return { ...state, funds: action.payload, loading: false };
    case CREATE_FUND_FAILED:
      return { ...state, loading: false };
    case GET_SPECIALITIES_INIT:
      return { ...state, subLoading: true };
    case GET_SPECIALITIES_SUCCESS:
      let speciality = [];
      action.payload?.subSpecialties?.map(({ name, id }) => {
        return speciality.push({
          value: name,
          label: name,
          id: id,
        });
      });
      return {
        ...state,
        specialities: speciality,
        subLoading: false,
      };
    case GET_SPECIALITIES_FAILED:
      return { ...state, subLoading: false };
    default:
      return state;
  }
}
